import { CommonModule } from "@angular/common";
import { Component, inject, OnInit, AfterViewInit } from "@angular/core";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { format } from "date-fns";
import { Observable } from "rxjs";
import { ExpandableTableComponent } from "../../../components/common/expandable-table/expandable-table.component";
import { LoadingComponent } from "../../../components/common/loading/loading.component";
import { AgentCreateModalComponent } from "../../../components/modal-templates/agent-create-modal/agent-create-modal.component";
import {
  releaseDummyData,
  releaseFields,
  releaseFieldsEdit,
} from "../../../core/dummy/dummy-data";
import { Release } from "../../../core/models/release-fields";
import { ReleaseActions } from "../../../core/ngrx/actions/release.actions";
import {
  selectRelease,
  selectReleaseError,
  selectReleaseLoading,
} from "../../../core/ngrx/selectors/release.selectors";
import { MaterialModule } from "../../../core/shared/material.module";
import { releasesTableColumns } from "../../../core/table-templates/releases-table";
import { BaseLayoutComponent } from "../../base-layout.component";

@Component({
  selector: "app-release",
  standalone: true,
  imports: [
    ExpandableTableComponent,
    LoadingComponent,
    MaterialModule,
    CommonModule,
  ],
  templateUrl: "./release.component.html",
  styleUrl: "./release.component.scss",
})
export class ReleaseComponent extends BaseLayoutComponent implements OnInit, AfterViewInit {
  isLoading: boolean = false;
  options: any;
  dataSource: any;
  columns: any;
  private modalService = inject(NgbModal);
  selectedReleases: any = [];
  releases: any = [];
  projectId: string = "";

  release$: Observable<Release[]> = this.store.select(selectRelease);
  loadingRelease$: Observable<boolean> =
    this.store.select(selectReleaseLoading);
  errorConnection$: Observable<string | null> =
    this.store.select(selectReleaseError);
  iconSrcDelete: string = '';

  ngAfterViewInit() {
    this.iconSrcDelete = `${this.basePath}assets/images/virtusa-icons/remove-icon-dark.svg`;
  }

  ngOnInit() {
    this.projectId = this.route.snapshot.paramMap.get("id") as string;

    this.columns = releasesTableColumns;
    this.dataSource = releaseDummyData;
    this.options = {
      isExpandable: false,
    };

    //load releases
    this.release$.subscribe((data: any) => {
      this.releases = data || [];
    });

    // Initialize the loading state
    this.loadingRelease$.subscribe((loading) => {
      this.isLoading = loading;
    });
  }

  handleActionsInTable(event: any) {
    if (event.type == "svg") {
      this.editRelease(event.data?.row);
    }
  }

  handleRowSelect(event: any) {
    this.selectedReleases = event?.data;
  }

  openGenericModal(isEdit: boolean, rowData?: any) {
    let data = {
      displayName: isEdit ? "Update Release" : "Add New Release",
      saveBtnText: isEdit ? "Update" : "Add",
    };

    const modalRef = this.modalService.open(AgentCreateModalComponent, {
      centered: true,
      size: "lg",
      windowClass: "add-item-modal",
      backdrop: 'static',
    });
    modalRef.componentInstance.configs = {
      title: data.displayName,
      saveBtnText: data.saveBtnText,
      isEdit: isEdit,
      model: rowData,
    };
    modalRef.componentInstance.fields = isEdit
      ? releaseFieldsEdit
      : releaseFields;

    modalRef.result.then((result: any) => {
      console.log(result);
      const formattedData = {
        ...result?.value,
        startDate: format(
          new Date(result?.value?.startDate),
          "yyyy-MM-dd'T'HH:mm:ss.SSSSSS"
        ),
        releaseDate: format(
          new Date(result?.value?.releaseDate),
          "yyyy-MM-dd'T'HH:mm:ss.SSSSSS"
        ),
      };

      if (isEdit) {
        //edit release
        this.store.dispatch(
          ReleaseActions.updateRelease({
            projectId: this.projectId,
            releaseId: rowData?.id,
            release: {
              name: rowData.name,
              id: rowData.id,
              ...formattedData,
            },
          })
        );
      } else {
        //create release
        this.store.dispatch(
          ReleaseActions.createRelease({
            projectId: this.projectId,
            release: formattedData,
          })
        );
      }
    });
  }

  removeReleases() {
    let releaseIds = Object.values(this.selectedReleases).map(
      (item: any) => item.id
    );
    this.store.dispatch(
      ReleaseActions.removeRelease({
        projectId: this.projectId,
        releaseIdList: releaseIds,
      })
    );
    this.selectedReleases = [];
  }

  addNewRelease() {
    this.openGenericModal(false);
  }

  editRelease(data: any) {
    this.openGenericModal(true, data);
  }

  changeRemoveIcon(isActive: boolean) {
    this.iconSrcDelete = isActive
      ? `${this.basePath}assets/images/virtusa-icons/remove-icon-light.svg`
      : `${this.basePath}assets/images/virtusa-icons/remove-icon-dark.svg`;
  }
}
